module.exports = __webpack_public_path__ + "static/media/tomas_aranda.90c45c30.jpg";